import {
  Directive,
  ElementRef,
  Renderer2,
  AfterViewInit,
  inject,
  OnDestroy,
} from '@angular/core';

@Directive({
  selector: '[coreTableEllipsis]',
})
export class TableEllipsisDirective implements AfterViewInit, OnDestroy {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);
  private observer!: MutationObserver;

  ngAfterViewInit() {
    this.applyEllipsis();

    this.observer = new MutationObserver(() => this.applyEllipsis());
    this.observer.observe(this.el.nativeElement, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  ngOnDestroy() {
    this.observer?.disconnect();
  }

  private applyEllipsis() {
    const tds = this.el.nativeElement.querySelectorAll('td');

    tds.forEach((td: HTMLElement) => {
      if (this.containsOnlyText(td)) {
        if (!td.classList.contains('ellipsis-applied')) {
          td.classList.add('ellipsis-applied');
          this.renderer.setStyle(td, 'overflow', 'hidden');
          this.renderer.setStyle(td, 'text-overflow', 'ellipsis');
          this.renderer.setStyle(td, 'white-space', 'nowrap');
        }
      } else {
        if (td.classList.contains('ellipsis-applied')) {
          td.classList.remove('ellipsis-applied');
          this.renderer.removeStyle(td, 'overflow');
          this.renderer.removeStyle(td, 'text-overflow');
          this.renderer.removeStyle(td, 'white-space');
        }
      }
    });
  }

  private containsOnlyText(element: HTMLElement): boolean {
    const children = element.children;

    if (children.length === 0) {
      const textContent = element.textContent?.trim();
      return textContent ? textContent.length > 0 : false;
    }

    for (let i = 0; i < children.length; i++) {
      const child = children[i];

      if (child.nodeType === Node.ELEMENT_NODE) {
        return false;
      }
    }

    const textContent = element.textContent?.trim();
    return textContent ? textContent.length > 0 : false;
  }
}
